import React from "react";
import cx from "classnames";
import parseDate from "utils/parseDate";

import styles from "components/Shared/EventCard/EventCard.module.scss";

function EventCardMini({ details }) {
  let date = parseDate(details.start_date);
  let spotsRemaining = details.attendees_limit - details.attendees.length;
  return (
    <a
      aria-label={`${details.name} event details`}
      href={details._id && `/event/${details._id && details._id}`}
      className={cx(styles.eventcardMini, {
        [styles.eventcard__isCancelled]: details.cancelled == true,
      })}
    >
      <div
        className={styles.eventcardMini__image}
        style={{ backgroundImage: `url("${details.eventImage}?w=350")` }}
      ></div>
      {details.venue_type === "Virtual" && !details.cancelled && (
        <div className={styles.eventcardMini__virtual}>Virtual</div>
      )}
      {details.cancelled && (
        <svg
          className={styles.eventcard__cancelledFlag}
          width="108"
          height="77"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            y="55"
            width="110"
            height="25"
            rx="6"
            transform="rotate(-30 0 55)"
            fill="#DD5D39"
          />
          <path
            d="M22.043 54.758l-1.883 1.808c-.39-.486-.813-.802-1.268-.95-.46-.154-.96-.076-1.5.236-.624.36-.978.855-1.065 1.485-.086.63.09 1.325.527 2.083.43.743.922 1.25 1.477 1.519.56.257 1.166.198 1.819-.18.593-.342.928-.775 1.005-1.3.077-.525-.013-1.089-.27-1.69l2.435-.956c.196.547.308 1.088.336 1.622a4.163 4.163 0 0 1-.204 1.544 4.16 4.16 0 0 1-.802 1.394c-.37.433-.851.821-1.444 1.164-.751.433-1.454.689-2.11.767a4.02 4.02 0 0 1-1.798-.177 4.212 4.212 0 0 1-1.483-.93 7.067 7.067 0 0 1-1.156-1.51 5.582 5.582 0 0 1-.666-1.777 4.57 4.57 0 0 1 .03-1.819 4.41 4.41 0 0 1 .78-1.666c.395-.528.927-.985 1.595-1.371.563-.325 1.11-.54 1.639-.646a4.017 4.017 0 0 1 1.51-.061c.47.069.917.226 1.34.472.417.24.803.552 1.156.939zm4.979 4.27l-1.66-9.999 2.33-1.346 7.841 6.431-2.173 1.255-1.32-1.144-3.175 1.833.33 1.716-2.173 1.255zm.89-7.869l.616 3.172 2.173-1.254-2.462-2.106-.54-.545.213.733zM36.847 46l3.185 5.517-2.049 1.183-4.745-8.219 2.59-1.495 5.872 3.905.584.519-.519-.796-3.055-5.292 2.049-1.183 4.745 8.219-2.477 1.43-6.134-4.1-.65-.525.604.837zm16.57-9.356l-1.883 1.808c-.39-.485-.813-.802-1.269-.95-.46-.154-.96-.076-1.5.236-.623.36-.977.855-1.064 1.486-.086.63.09 1.324.527 2.082.43.743.922 1.25 1.477 1.519.56.258 1.166.198 1.819-.18.592-.341.928-.775 1.005-1.3.077-.525-.013-1.088-.27-1.69l2.435-.956c.196.547.308 1.088.336 1.622a4.162 4.162 0 0 1-.204 1.544 4.16 4.16 0 0 1-.802 1.394c-.37.434-.852.822-1.444 1.164-.751.433-1.454.689-2.11.767a4.02 4.02 0 0 1-1.798-.177 4.212 4.212 0 0 1-1.483-.93 7.07 7.07 0 0 1-1.156-1.51 5.585 5.585 0 0 1-.666-1.777 4.573 4.573 0 0 1 .03-1.819 4.41 4.41 0 0 1 .78-1.665c.395-.529.927-.986 1.595-1.372.563-.325 1.11-.54 1.639-.646a4.017 4.017 0 0 1 1.51-.061 3.7 3.7 0 0 1 1.34.473 4.78 4.78 0 0 1 1.156.938zm5.852 3.766l-4.744-8.218 6.316-3.647 1.007 1.745-4.267 2.464.917 1.587 3.298-1.904.865 1.497-3.299 1.905.936 1.62 4.357-2.515 1.02 1.768-6.405 3.698zm9.33-5.386l-4.745-8.219 2.161-1.247 3.608 6.248 3.906-2.256 1.138 1.97-6.068 3.504zm8.922-5.151l-4.745-8.219 6.316-3.646 1.008 1.745-4.267 2.463.916 1.588 3.299-1.905.864 1.497-3.298 1.905.936 1.621 4.357-2.515 1.02 1.767-6.406 3.699zm9.33-5.387l-4.746-8.218 3.153-1.82c1.403-.81 2.682-1.083 3.835-.819 1.15.258 2.101 1.04 2.855 2.345.351.608.58 1.221.687 1.84.107.619.089 1.22-.055 1.803-.147.576-.431 1.125-.85 1.647-.416.51-.973.967-1.671 1.37l-3.209 1.852zm-.755-8.195l-.878.506 2.75 4.763.957-.553c.773-.446 1.218-.993 1.334-1.64.116-.648-.046-1.355-.488-2.12-.464-.804-.993-1.279-1.589-1.425-.587-.151-1.282.005-2.086.469z"
            fill="#fff"
          />
        </svg>
      )}
      {details.host && (
        <div className={styles.eventcardMini__host}>
          {
            <img
              src={
                details.host.hostImage
                  ? details.host.hostImage + "?w=100&h=100"
                  : "/placeholder/placeholder-profile-image.png"
              }
              alt={`${details.host.first_name} Profile Image`}
            />
          }
          <h4>{details.host.first_name && details.host.first_name}</h4>
        </div>
      )}
      <div className={styles.eventcardMini__info}>
        <div className={styles.eventcardMini__top}>
          <div className={styles.eventcardMini__top__date}>
            <p>
              {date.month && date.month}
              <br />
              <span>{date.day && date.day}</span>
            </p>
            <div className={styles.eventcardMini__top__icon}>
              {details.type === "Book club" && (
                <img
                  src="/icons/bookclub-icon-black.svg"
                  alt="book club icon"
                />
              )}
              {details.type === "Cookbook club" && (
                <img
                  src="/icons/cookbook-icon-black.svg"
                  alt="book club icon"
                />
              )}
              {details.type !== "Book club" &&
                details.type !== "Cookbook club" && (
                  <img
                    src="/icons/othergathering-icon-black.svg"
                    alt="book club icon"
                  />
                )}
            </div>
          </div>
          <div className={styles.eventcardMini__top__info}>
            {details.type && <h3>{details.type}</h3>}
            <h4>{details.name && details.name}</h4>
            <p>
              {date.dayOfWeek && date.dayOfWeek}{" "}
              {`${date.hour && date.hour}:${
                date.minutes === 0 ? "00" : date.minutes
              }${date.ampm && date.ampm}`}{" "}
              {date.timeZone && date.timeZone}
            </p>
            {details.venue_type !== "Virtual" && (
              <p>
                {details.neighborhood && details.neighborhood},{" "}
                {details.community && details.community}
              </p>
            )}
          </div>
        </div>
        <div className={styles.eventcardMini__bottom}>
          <p>
            Members{" "}
            {details.guest_limit && details.guest_limit > 0
              ? ` + ${details.guest_limit} Guest${
                  details.guest_limit > 1 ? "s" : ""
                }`
              : ``}
          </p>
          {!details.cancelled && (
            <p>
              {spotsRemaining > 0 ? spotsRemaining : 0} /&nbsp;
              {details.attendees_limit} spots remaining
            </p>
          )}
        </div>
      </div>
    </a>
  );
}

export default EventCardMini;
